module.exports = __webpack_public_path__ + "img/gallery-image-8.e4a9bbde.jpg";